import { GlLink } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { TYPE_ISSUE, TYPE_MERGE_REQUEST } from '~/issues/constants';
import { isGid, getIdFromGraphQLId } from '~/graphql_shared/utils';
import AssigneeAvatar from './assignee_avatar.vue?vue3';
export default {
    name: 'AssigneeAvatarLink',
    components: {
        AssigneeAvatar,
        GlLink
    },
    props: {
        user: {
            type: Object,
            required: true
        },
        issuableType: {
            type: String,
            default: TYPE_ISSUE,
            required: false
        }
    },
    computed: {
        isMergeRequest () {
            return this.issuableType === TYPE_MERGE_REQUEST;
        },
        cannotMerge () {
            const canMerge = this.user.mergeRequestInteraction?.canMerge || this.user.can_merge;
            return this.isMergeRequest && !canMerge;
        },
        assigneeUrl () {
            return this.user.web_url || this.user.webUrl;
        },
        assigneeId () {
            return isGid(this.user.id) ? getIdFromGraphQLId(this.user.id) : this.user.id;
        }
    }
};
